export default __webpack_public_path__ + "static/media/bathtub.359e1bce.svg";